export interface PriWord {
  en: string;
  ar: string;
}

/**
 * The Arabic brand word, tatweel-stretched (U+0640 padding) for the hero's
 * kashida display treatment, carrying the locked fatha on the ر (U+064E, see
 * docs/arabic-style-guide.md §6) — برَينوتس reads "bray", not "bree".
 *
 * Split into the teal "PRI" segment + the ink remainder, mirroring the EN
 * "Pri" prefix split. These are the single source of truth: TypewriterAR
 * renders from them rather than re-declaring the literals, so the word list
 * and the colour split cannot drift apart (they did — the fatha was added to
 * the brand everywhere else on 2026-07-14 and this stretched copy was missed,
 * because the tatweel padding hides it from a plain "برينوتس" search).
 */
export const AR_BRAND_PRI = 'بــرَيــ';
export const AR_BRAND_REST = 'نــوتــس';
export const AR_BRAND = `${AR_BRAND_PRI}${AR_BRAND_REST}`;

/**
 * LOCKED 2026-05-25 — canvas/hero-lab.html lines 1033-1039.
 * Tatweel variant B approved; renderArSpans splits the brand into the teal
 * prefix + suffix to mirror the EN "Pri" teal prefix + suffix split.
 */
export const PRI_WORDS: readonly PriWord[] = [
  { en: 'Privacy', ar: 'خـصـوصـيـة' },
  { en: 'Priority', ar: 'أولــــويــــة' },
  { en: 'Prime', ar: 'امــتــيــاز' },
  { en: 'Principles', ar: 'مـــــبـــــادئ' },
  { en: 'Prinotes', ar: AR_BRAND },
] as const;
